module.exports = "/desktop-app/assets/img/mailbox.svg?426e863fdf31ebe5371adc9bd21f3560";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/svg/mailbox.svg
// module id = ob0C
// module chunks = 1